import { DonationUnit, DonationFailedReason } from 'gql/types';
import {
  donationUnitSchema,
  actualSchema,
  failedReasonSchema,
  approvedDonationsMlSchema,
} from 'modules/donations/schemas';
import * as yup from 'yup';

type QuantitySchemaType = {
  approvedDonationsMl: number;
  unit?: DonationUnit;
  actual?: number;
  failedReason?: DonationFailedReason;
};

const quantitySchema: yup.SchemaOf<QuantitySchemaType> = yup.object().shape(
  {
    approvedDonationsMl: approvedDonationsMlSchema,
    unit: donationUnitSchema,
    actual: actualSchema,
    failedReason: failedReasonSchema,
  },
  [['unit', 'actual']]
);

export { quantitySchema };
export type { QuantitySchemaType };
